import React from "react";
import "./stepper.css";

const steps = [
    "Address",
    "Select Services",
    "Pick Up/Drop Off Time",
    "Order Summary"
];


const Stepper = ({currentStep = 1}) => {
    return (
        <div className="stepper">
            {steps.map((step, index) => {
                const isActive = index <= currentStep;

                return (
                    <div className="step" key={index}>
                        {index !== 0 && (
                            <div className={`line ${isActive ? "active" : ""}`}/>
                        )}

                        <div className={`dot ${isActive ? "active" : ""}`}/>

                        <div className="label">{step}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default Stepper;
